export const illigalCharacterValidation = (element, inputTitle) => {

    return alphanumeric(element,inputTitle);
}

function alphanumeric(string, inputTitle) {
    let result = {
        isValid: true,
        message: ""
    }

    if(string === '')
    {
        result.isValid = false;
        result.message = inputTitle + ' cannot be empty'
        return result;
    }

    let letters1 = /[a-zA-Z]/;
    if (!letters1.test(string)) {
        result.isValid = false
        result.message = inputTitle + ' have to contain at least 1 letter';
        return result;
    }
    
    let letters2 = inputTitle !== "Url" && inputTitle !== 'Mail' ? /^[0-9a-zA-Z\s-_()&]+$/ : /^[0-9a-zA-Z]+$|^[0-9a-zA-Z][0-9a-zA-Z_-]*[0-9a-zA-Z]$/;
    
    if (letters2.test(string)) {
        return result;
    } else {
        let illegalChars = [];
            string.split("").forEach(element => {
                if(!letters2.test(element)){illegalChars.push(element)}
            });
        result.isValid = false
        result.message = inputTitle + ' contains illegal characters: ' + illegalChars.toString();
        return result;
    }

}


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Validation/IlligalCharactersValidation.js